import axios from 'axios';
import { axiosRequest, handleHttpResponse, DHLError } from '@general/js/utils';
import AbstractClass from './CommonAbstractServices';
import { Services } from '../Services';

export default class CommonServices extends AbstractClass {
  /**
   * Call api to refresh cookie. It also check if user is logged in or not.
   * Does not expect any return
   */
  static async getRefreshCookie() {
    try {
      const response = await axios.get(Services.COMMON.REFRESH_COOKIE);
      if(handleHttpResponse(response)){
        return response.data;
      };
      throw new DHLError(`getRefreshCookie() - unexpected results from server: ${JSON.stringify(response.data)}`);
    } catch (error) {
      throw new DHLError(`getRefreshCookie() - call failed with error: ${JSON.stringify(error.message)}`, error);
    }
  }

  /**
   * Implicitly returns a Promise for fetching header, footer, memberDetailsInformation and memberDetailsMenu data from Kentico.
   * // FIXME: after DIG-3457, this api should not return memberDetailsInformation
   */
  static async getNavigationAndMemberDetails() {
    try {
      const response = await axiosRequest().get(Services.COMMON.GET_NAVIGATION_AND_MEMBER_DETAILS);
      const keysToHave = ['header', 'footer', 'memberDetailsInformation', 'memberDetailsMenu', 'underMaintenance'];

      if (
        handleHttpResponse(response) &&
        Object.keys(response.data).every((key) => {
          return keysToHave.includes(key);
        })
      ) {
        return response.data;
      }

      throw new DHLError(`Unexpected data structure returned for data: ${JSON.stringify(response.data)}`);
    } catch (error) {
      throw new DHLError(`getNavigationAndMemberDetails() - call failed with error: ${JSON.stringify(error.message)}`, error);
    }
  }

  /**
   * Take search term and use to get search suggestions
   * @param {string} searchText search term user input
   * @returns {object}
   */
  static async getSearchPrediction(searchText) {
    try {
      const response = await axiosRequest().get(Services.COMMON.SEARCH.GET_SEARCH_PREDICTION, {
        params: { searchText },
      });

      if (handleHttpResponse(response) && response.data.suggestions) {
        return response.data.suggestions;
      }
      throw new DHLError(`Unexpected data structure returned for data: ${JSON.stringify(response.data)}`);
    } catch (error) {
      throw new DHLError(`getSearchPrediction() - Call failed with error: ${JSON.stringify(error.message)}`, error);
    }
  }

  /**
   * API to get search results
   * @param {string} searchText search term
   * @param {number} pageNum integer represents page number of search results page
   * @param {number} pageSize integer represents page size of search results page
   * @returns {object}
   */
  static async getSearchResults(searchText, pageNum, pageSize = 10) {
    try {
      const response = await axiosRequest().get(Services.COMMON.SEARCH.GET_SEARCH_RESULTS, {
        params: { searchText, pageNum, pageSize },
      });

      if (handleHttpResponse(response) && response.data.results) {
        // return member number string token swapped data
        return JSON.parse(JSON.stringify(response.data).tokenSwap());
      }

      throw new DHLError(`Unexpected data structure returned for data: ${JSON.stringify(response.data)}`);
    } catch (error) {
      throw new DHLError(`getSearchResults() - Call failed with error: ${JSON.stringify(error.message)}`, error);
    }
  }

    /**
   * Function to raise a work item for submit policy flow.
   *
   * @param {string} memberNumber Member number
   * @param {object} payload Failed payload when submit policy flow fails 
   */
    static async raiseWorkItem(memberNumber, payload) {
      try {
        const response = await axiosRequest().post(Services.COMMON.POST_COMMON_WORK_ITEM(memberNumber), payload);
  
        return handleHttpResponse(response);
      } catch (error) {
        throw new DHLError(`raiseWorkItem() - call failed with error: ${JSON.stringify(error.message)}`, error);
      }
    }
}
